export class ClassNames {
    public static readonly Active = 'active';
    public static readonly AlignCenter = 'align-middle';
    public static readonly AlignLeft = 'align-left';
    public static readonly AlignRight = 'align-right';
    public static readonly BannerLightGray = 'banner-light-gray';
    public static readonly BasicLabel = 'basic-label';
    public static readonly BannerWhite = 'banner-white';
    public static readonly BackgroundDark = 'bg-dark';
    public static readonly BackgroundLight = 'bg-light';
    public static readonly BackgroundWhite = 'bg-white';
    public static readonly Black = 'black';
    public static readonly Block = 'block';
    public static readonly BorderDark = 'border-dark';
    public static readonly BorderLight = 'border-light';
    public static readonly Bottom = 'bottom';
    public static readonly BottomLeft = 'bottom left';
    public static readonly BottomRight = 'bottom right';
    public static readonly ButtonSuccess = 'btn btn-success';
    public static readonly Card = 'card';
    public static readonly CardCompass = 'card-compass';
    public static readonly Center = 'center';
    public static readonly CardBody = 'card-body';
    public static readonly CardFooter = 'card-footer';
    public static readonly CardInverse = 'card-inverse';
    public static readonly CardHeader = 'card-header';
    public static readonly CellClickable = 'cell-clickable';
    public static readonly Checkable = 'checkable';
    public static readonly ColumnCurrency = 'column-currency';
    public static readonly Counter = 'counter';
    public static readonly DropUp = 'drop-up';
    public static readonly DropdownToggle = 'dropdown-toggle';
    public static readonly Empty = 'empty';
    public static readonly FilterableHeader = 'filterable-header';
    public static readonly FormGroup = 'form-group';
    public static readonly RowActions = 'row-actions';
    public static readonly FeeBreakdownPopover = 'fee-breakdown-popover';
    public static readonly Grey = 'grey';
    public static readonly GreenBorderBottom = 'green-border-bottom';
    public static readonly GrandTotal = 'grand-total';
    public static readonly HasIcon = 'has-icon';
    public static readonly HasBasicLabel = 'has-basic-label';
    public static readonly HasInnerLabel = 'has-inner-label';
    public static readonly HasInnerLeftLabel = 'has-inner-left-label';
    public static readonly HasFloatLabel = 'has-float-label';
    public static readonly HasSorted = 'has-sorted';
    public static readonly HiddenCell = 'hidden-cell';
    public static readonly InputGroup = 'input-group';
    public static readonly Invisible = 'invisible';
    public static readonly IsFocused = 'is-focused';
    public static readonly IsInvalid = 'is-invalid';
    public static readonly IsExpanded = 'is-expanded';
    public static readonly IsFocusedOrFilled = 'is-focused-or-filled';
    public static readonly JsonCell = 'json-cell';
    public static readonly Link = 'link';
    public static readonly Large = 'lg';
    public static readonly Left = 'left';
    public static readonly Light = 'light';
    public static readonly ListInline = 'list-inline';
    public static readonly ListUnstyled = 'list-unstyled';
    public static readonly Medium = 'md';
    public static readonly MobileBannerTab = 'mobile-banner-tab';
    public static readonly MobileBannerWithTabs = 'mobile-banner-with-tabs';
    public static readonly MobileBannerDateFilter = 'mobile-banner-date-filter';
    public static readonly NgDirty = 'ng-dirty';
    public static readonly NgInvalid = 'ng-invalid';
    public static readonly StackEagerly = 'stack-eagerly';
    public static readonly NotSortable = 'not-sortable';
    public static readonly Open = 'open';
    public static readonly PopoverIcon = 'popover-icon';
    public static readonly Right = 'right';
    public static readonly RouterLinkActive = 'active';
    public static readonly Search = 'search';
    public static readonly SelectGroup = 'select-group';
    public static readonly Sortable = 'sortable';
    public static readonly Small = 'sm';
    public static readonly ScreenReaderOnly = 'sr-only';
    public static readonly SpacerColumn = 'spacer-column';
    public static readonly TableCellPopoverIcon = 'table-cell-popover-icon';
    public static readonly TableHeaderPopover = 'table-header-popover';
    public static readonly TableHeaderPopoverDefaults = `${ClassNames.TableHeaderPopover} md`;
    public static readonly TableHeaderPopoverInline = `${ClassNames.TableHeaderPopover} inline`;
    public static readonly TestChild = 'child1';
    public static readonly TestLogin = 'login';
    public static readonly TestParent = 'parent';
    public static readonly TextDanger = 'text-danger';
    public static readonly ThWithPopover = 'th-with-popover';
    public static readonly ShowingChildren = 'showing-children';
    public static readonly TextBold = 'text-bold';
    public static readonly TextCenter = 'text-center';
    public static readonly TextLeft = 'text-left';
    public static readonly TextLowercase = 'text-lowercase';
    public static readonly TextNowrap = 'text-nowrap';
    public static readonly TextRight = 'text-right';
    public static readonly TextTruncate = 'text-truncate';
    public static readonly TextWrapTableCell = 'text-wrap';
    public static readonly TextUppercase = 'text-uppercase';
    public static readonly Top = 'top';
    public static readonly TopContent = 'top-content-';
    public static readonly TopContentSearchBar = 'top-content-search-bar';
    public static readonly TopLeft = 'top left';
    public static readonly TopRight = 'top right';
    public static readonly Expanded = 'expanded';
    public static readonly IsGroup = 'is-group';
    public static readonly IsMemberOfGroup = 'is-member-of-group';
}
